import { render, staticRenderFns } from "./TrackingLocal.vue?vue&type=template&id=1c85d223"
import script from "./TrackingLocal.vue?vue&type=script&lang=js"
export * from "./TrackingLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports